// extracted by mini-css-extract-plugin
module.exports = {"features-title":"features-title___9qXUD"};